var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("history")]
                      ),
                      _vm._v("\n          Job Runs\n        "),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        View ingestion job run history and results.\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        flat: "",
                        dark: "",
                        to: { name: "ingestionDashboard" },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v("Back to Dashboard\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "", "pa-1": "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Status",
                              items: _vm.statusOptions,
                              clearable: "",
                            },
                            on: { change: _vm.onFilterChange },
                            model: {
                              value: _vm.filter.Status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filter, "Status", $$v)
                              },
                              expression: "filter.Status",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "", "pa-1": "" } },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "offset-y": "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            attrs: {
                                              label: "From Date",
                                              readonly: "",
                                              clearable: "",
                                            },
                                            on: {
                                              "click:clear": function ($event) {
                                                _vm.filter.from = null
                                                _vm.onFilterChange()
                                              },
                                            },
                                            model: {
                                              value: _vm.filter.from,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filter,
                                                  "from",
                                                  $$v
                                                )
                                              },
                                              expression: "filter.from",
                                            },
                                          },
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.fromMenu,
                                callback: function ($$v) {
                                  _vm.fromMenu = $$v
                                },
                                expression: "fromMenu",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("v-date-picker", {
                                on: {
                                  input: function ($event) {
                                    _vm.fromMenu = false
                                    _vm.onFilterChange()
                                  },
                                },
                                model: {
                                  value: _vm.filter.from,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filter, "from", $$v)
                                  },
                                  expression: "filter.from",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "", "pa-1": "" } },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "offset-y": "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            attrs: {
                                              label: "To Date",
                                              readonly: "",
                                              clearable: "",
                                            },
                                            on: {
                                              "click:clear": function ($event) {
                                                _vm.filter.to = null
                                                _vm.onFilterChange()
                                              },
                                            },
                                            model: {
                                              value: _vm.filter.to,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.filter, "to", $$v)
                                              },
                                              expression: "filter.to",
                                            },
                                          },
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.toMenu,
                                callback: function ($$v) {
                                  _vm.toMenu = $$v
                                },
                                expression: "toMenu",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("v-date-picker", {
                                on: {
                                  input: function ($event) {
                                    _vm.toMenu = false
                                    _vm.onFilterChange()
                                  },
                                },
                                model: {
                                  value: _vm.filter.to,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filter, "to", $$v)
                                  },
                                  expression: "filter.to",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "", "pa-1": "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Config ID",
                              type: "number",
                              clearable: "",
                            },
                            on: {
                              input: _vm.debounceFilterChange,
                              "click:clear": _vm.onFilterChange,
                            },
                            model: {
                              value: _vm.filter.configId,
                              callback: function ($$v) {
                                _vm.$set(_vm.filter, "configId", $$v)
                              },
                              expression: "filter.configId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.jobs,
                  loading: _vm.loading,
                  "total-items": _vm.jobsTotalCount,
                  pagination: _vm.pagination,
                  "rows-per-page-items": [10, 20, 50],
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "max-width": "150px",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                            },
                            attrs: { title: props.item.Id },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/administration/ingestion-jobs/${props.item.Id}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.shorten(props.item.Id)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            props.item.ConfigurationId
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: { to: { name: "ingestionConfigs" } },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.configName(
                                            props.item.ConfigurationId
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: _vm.statusColor(props.item.Status),
                                  small: "",
                                  dark: "",
                                },
                              },
                              [_vm._v(_vm._s(props.item.Status))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(props.item.StartedAt))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDuration(props.item.DurationSeconds)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "info",
                                  depressed: "",
                                  to: `/administration/ingestion-jobs/${props.item.Id}`,
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackColor, timeout: 6000, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }